export default __webpack_public_path__ + "static/media/loghi.e3d6712a.png";